import { Typography } from '@euler/app/components/typography';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { ReactNode, memo } from 'react';
import { View } from 'react-native';

/** A labelled group of the editor form; `wrap` lays children as chips. */
export const EditorSection = memo(
  ({
    title,
    note,
    wrap,
    children,
  }: {
    title: string;
    note?: string;
    wrap?: boolean;
    children: ReactNode;
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <View style={{ gap: rpx(8) }}>
        <View
          style={{ flexDirection: 'row', alignItems: 'baseline', gap: rpx(8) }}
        >
          <Typography.Text medium size={rpx(13)} color={aiColors.foreground}>
            {title}
          </Typography.Text>
          {note ? (
            <Typography.Text size={rpx(11)} color={aiColors.mutedForeground}>
              {note}
            </Typography.Text>
          ) : null}
        </View>
        <View
          style={
            wrap
              ? { flexDirection: 'row', flexWrap: 'wrap', gap: rpx(6) }
              : { gap: rpx(8) }
          }
        >
          {children}
        </View>
      </View>
    );
  },
);
